/**
 * @author: leroy
 * @date: 2021/10/30 15:53
 * @description：sentry.client.config.js
 */
import * as Sentry from '@sentry/nextjs';

Sentry.init({
  dsn: process.env.SENTRY_DSN,
  tracesSampleRate: 1.0,
});
